/* global swal:false */
;(function () {
  'use strict'

  angular.module('singin.service', []).factory('SigninService', SigninService)

  /** @ngInject */
  function SigninService($http, $q, API) {
    function signin(model) {
      var defer = $q.defer()

      $http
        .post(API.API_URL + 'users/signin', model)
        .success(defer.resolve)
        .error(function () {
          swal('User or password wrong!', '', 'error')
        })

      return defer.promise
    }

    function signinGoogle(token) {
      var defer = $q.defer()

      $http
        .post(API.API_URL + 'google/signin', {
          firebaseToken: token,
        })
        .success(defer.resolve)
        .error(defer.reject)

      return defer.promise
    }

    function signinApple(model) {
      var defer = $q.defer()

      $http
        .post(API.API_URL + 'apple/web/signin', model)
        .success(defer.resolve)
        .error(defer.reject)

      return defer.promise
    }

    function send2fa(model, token) {
      var defer = $q.defer()

      $http
        .post(API.API_URL + '2fa/send', model, {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        })
        .success(defer.resolve)
        .error(defer.reject)

      return defer.promise
    }

    function check2fa(model, token) {
      var defer = $q.defer()

      $http
        .post(API.API_URL + '2fa/check', model, {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        })
        .success(defer.resolve)
        .error(defer.reject)

      return defer.promise
    }

    return {
      signin: signin,
      signinGoogle: signinGoogle,
      signinApple: signinApple,
      send2fa: send2fa,
      check2fa: check2fa,
    }
  }
})()
